<template>
    <div v-if="currentVisible" class="resume-experience" :class="_platform" @click.self="handleMaskClick">
        <div class="resume-experience-content">
            <div class="resume-experience-header">
                <button class="resume-experience-cancel" @click="handleCancelClick">取消</button>
                <span class="resume-experience-header-title">选择您的{{ currentRadio.label }}</span>
                <button class="resume-experience-confirm" @click="handleConfirmClick">确定</button>
            </div>
            <ul class="resume-experience-radio-group">
                <li v-for="(item, index) in radios"
                    :key="index"
                    :class="{active: currentIndex === index}"
                    class="resume-experience-radio"
                    @click="handleRadioClick(index)"
                >
                    {{ item.label }}
                    <span v-if="Array.isArray(staticData[currentRadio.dataKey])" class="resume-experience-radio-value">{{ (staticData[item.dataKey].find(e => e.value === $data[item.key]) || {}).text }}</span>
                </li>
            </ul>
            <component :is="currentRadio.comp"
                       v-if="Array.isArray(staticData[currentRadio.dataKey])"
                       ref="currentComp"
                       v-model="$data[currentRadio.key]"
                       :scope="staticData[currentRadio.dataKey]"
            />
        </div>
    </div>
</template>

<script>
import data from '@/data';
import BirthScroll from './BirthSelect.vue';
import EduSelect from './EduSelect.vue';
import WorkSelect from './WorkSelect.vue';
export default {
    components: {BirthScroll, EduSelect, WorkSelect},
    props: {
        birth: {
            type: Number,
            default: 1999
        },
        edu: {
            type: Number,
            default: 3
        },
        work: {
            type: Number,
            default: 4
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            staticData: {},
            radios: [
                {label: '出生年份', key: 'currentBirth', dataKey: 'birthList', comp: 'BirthScroll', confirm: false},
                {label: '最高学历', key: 'currentEdu', dataKey: 'educationList', comp: 'EduSelect', confirm: false},
                {label: '工作时间', key: 'currentWork', dataKey: 'workYearList', comp: 'WorkSelect', confirm: false}
            ],
            currentIndex: 0,
            currentBirth: 1999,
            currentEdu: 3,
            currentWork: 3,
            show: true
        };
    },
    computed: {
        currentVisible: {
            set(v) {
                this.$emit('update:visible');
            },
            get() {
                return this.visible;
            }
        },
        currentRadio() {
            const radio = this.radios[this.currentIndex];
            radio.confirm = true;
            return radio;
        },
        _platform() {
            return window.urlParams?.platform;
        }
    },
    watch: {
        birth: {
            handler(v) {
                this.currentBirth = v;
            },
            immediate: true
        },
        edu: {
            handler(v) {
                this.currentEdu = v;
            },
            immediate: true
        },
        work: {
            handler(v) {
                this.currentWork = v;
            },
            immediate: true
        }
    },
    async created() {
        const staticData = await data();
        this.staticData = staticData.list;
    },
    mounted() {
        document.body.appendChild(this.$el);
    },
    methods: {
        handleMaskClick() {
            this.currentVisible = false;
        },
        handleRadioClick(i) {
            this.currentIndex = i;
        },
        handleConfirmClick() {
            const nextConfirmIndex = this.radios.findIndex((e) => !e.confirm);
            // 判断用户是否每个tab都确认过
            if (nextConfirmIndex > 0) {
                this.currentIndex = nextConfirmIndex;
                return;
            }
            this.$emit('confirm', {
                birth: this.currentBirth,
                edu: this.currentEdu,
                work: this.currentWork
            });
            this.currentVisible = false;
        },
        handleCancelClick() {
            this.$emit('cancel');
            this.currentVisible = false;
        }
    }
};
</script>


